import React from "react";
import PropTypes from "prop-types";

import TableChart from "./TableChart";

function ProviderTable({ chartData, className, isLoading, displayCurrencySymbol }) {
  const columns = [];

  chartData.columns.forEach((column, index) =>
    columns.push({
      Header: <span className="pl-9 no-wrap">{column}</span>,
      accessor: column,
      sortable: true,
      // eslint-disable-next-line react/prop-types
      Cell: ({ value }) => (
        <p className="pl-9 pt-8 pb-8 mb-0 no-wrap">
          {displayCurrencySymbol
            ? index !== 0
              ? Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  trailingZeroDisplay: "stripIfInteger",
                }).format(value)
              : value
            : value}
        </p>
      ),
    }),
  );

  return <TableChart className={className} isLoading={isLoading} columns={columns} data={chartData.content} />;
}

ProviderTable.propTypes = {
  chartData: PropTypes.instanceOf(Object).isRequired,
  className: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  displayCurrencySymbol: PropTypes.bool,
};

ProviderTable.defaultProps = {
  className: "",
  displayCurrencySymbol: false,
};

export default ProviderTable;
